import React from 'react';
import { Button, Checkbox, message } from 'antd';

const BaseDeleteFooter = (props) => {
  const { id, title, boxTitle, boxContents, buttonTitle, onDeleted, data, ...rest } =
    props;
  const [deleted, setDeleted] = React.useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      // alignItems: 'flex-start',
      width: '100%',
      height: '27.6rem',
      padding: '2.4rem',
      background: '#FFFFFF',
      boxShadow: '0px 4px 18px rgba(75, 70, 92, 0.1)',
      borderRadius: 6,

      // font
      fontFamily: 'Public Sans',
      fontStyle: 'normal',
    },
    title: {
      display: 'flex',
      alignItems: 'flex-start',
      // font
      // fontFamily: 'Public Sans',
      // fontStyle: 'normal',
      fontWeight: 600,
      fontSize: '1.8rem',
      lineHeight: '2.4rem',
    },
    box: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'center',
      height: '8rem',
      padding: '0rem 1.5rem 0rem 1.5rem',
      background: 'rgba(255, 159, 67, 0.16)',
      border: '1px solid rgba(255, 159, 67, 0.16)',
      borderRadius: 6,
    },
    box_title: {
      fontWeight: 600,
      fontSize: '1.8rem',
      lineHeight: '2.4rem',
      color: '#FF9F43',
    },
    box_contents: {
      marginTop: '1rem',
      fontWeight: 500,
      fontSize: '1.5rem',
      lineHeight: '2.2rem',
      color: '#FF9F43',
    },
    row: {
      display: 'flex',
      width: '100%',
      alignItems: 'center',
    },
    row_text: {
      display: 'flex',
      height: '100%',
      alignItems: 'center',
      marginLeft: '1rem',
      fontWeight: 400,
      fontSize: '1.5rem',
      lineHeight: '2.2rem',
    },
    botton_delete: {
      display: 'flex',
      // width: '15rem',
      // height: '8rem',
      alignItems: 'center',
      justifyContent: 'center',

      background: '#EA5455',
      boxShadow: '0px 2px 4px rgba(165, 163, 174, 0.3)',
      borderRadius: 6,
      color: '#FFF',

      // font
      fontWeight: 500,
      fontSize: '1.5rem',
      lineHeight: '1.8rem',
    },
  };

  return (
    <div style={{ ...styles.container }}>
      {contextHolder}
      <div style={{ ...styles.title }}>{title}</div>
      <div style={{ ...styles.box, marginTop: 24 }}>
        <div style={{ ...styles.box_title }}>{boxTitle}</div>
        <div style={{ ...styles.box_contents }}>{boxContents}</div>
      </div>
      <div style={{ ...styles.row, marginTop: 16 }}>
        <Checkbox
          defaultChecked={false}
          onChange={(e) => {
            // console.log('checked = ', e.target.checked);
            setDeleted(e?.target?.checked || false);
          }}
        />
        <div style={{ ...styles.row_text }}>{`주의사항을 확인하였습니다.`}</div>
      </div>
      <div style={{ ...styles.row, marginTop: 24 }}>
        <Button
          style={{ ...styles.botton_delete }}
          onClick={(e) => {
            if (deleted == true) {
              onDeleted();
            } else {
              // 주의 사항을 확인해 주세요
              messageApi.error(`주의 사항을 확인해 주세요`);
            }
          }}
        >
          {buttonTitle}
        </Button>
      </div>
    </div>
  );
};

export default BaseDeleteFooter;
